import { Button, Text } from '@/ui-kit'
import { Trans } from '@lingui/react/macro'
import { isProlificMode } from '../../prolific/session'

type NoTasksAvailableProps = {
	onBack: () => void
	retry?: boolean
	onRetry?: () => void
}

export function NoTasksAvailable({ onBack, retry, onRetry }: NoTasksAvailableProps) {
	const prolificMode = isProlificMode()

	if (retry) {
		return (
			<div className="mx-auto mt-10 flex w-full max-w-[600px] flex-col items-center gap-4 rounded-2xl border border-solid border-gray-100 px-10 py-12 text-center">
				<Text type="h5" className="text-gray-70">
					<Trans>Something went wrong</Trans>
				</Text>
				<Text type="body2-regular" className="text-gray-80">
					<Trans>We couldn&rsquo;t load the next topic. Please try again.</Trans>
				</Text>
				{onRetry && (
					<Button size="small" onClick={onRetry} className="mt-2">
						<Trans>Try again</Trans>
					</Button>
				)}
			</div>
		)
	}

	return (
		<div className="mx-auto mt-10 flex w-full max-w-[600px] flex-col items-center gap-4 rounded-2xl border border-solid border-gray-100 px-10 py-12 text-center">
			<Text type="h5" className="text-gray-70">
				<Trans>No tasks available right now</Trans>
			</Text>
			<Text type="body2-regular" className="text-gray-80">
				<Trans>There are no topics for you at the moment. Please check back later.</Trans>
			</Text>
			{!prolificMode && (
				<Button size="small" onClick={onBack} className="mt-2">
					<Trans>Back to Missions</Trans>
				</Button>
			)}
		</div>
	)
}
